export interface ProgressProps {
  className?: string;
  label: string;
  value: number;
}

export function Progress({ className = "", label, value }: ProgressProps) {
  const normalizedValue = Math.min(100, Math.max(0, value));

  return (
    <div
      aria-label={label}
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={Math.round(normalizedValue)}
      className={`h-1.5 overflow-hidden rounded-full bg-line/80 shadow-inner ${className}`}
      role="progressbar"
    >
      <div
        aria-hidden="true"
        className="h-full rounded-full bg-gradient-to-r from-accent via-accent to-highlight transition-[width] motion-reduce:transition-none"
        style={{ width: `${normalizedValue}%` }}
      />
    </div>
  );
}
